import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  AddPaymentIntent,
  CheckGiftCardCode,
  ConfirmGiftCardPaymentTransaction,
  ConfirmPaymentTransaction,
  FetchPaymentIntent,
  RegisterPayment,
  RemoveGiftCard,
  RemovePaymentIntent,
} from './payment.action';
import { Observable } from 'rxjs';
import * as selector from './payment.selector';
import { FilterState } from 'src/app/modules/shared/models/filter-state';
import { RegisterDirectPayment } from '../../models/register-payment';
import { PaymentIntent, PaymentIntentRequest } from '../../models/paymentIntent';
import { GiftCard } from '../../models/gift-card';
import { Booking } from 'src/app/modules/booking/models/booking';
import { PaymentState } from '@modules/payment/client/store/payment.state';

@Injectable()
export class PaymentStoreService {
  constructor(private store: Store<PaymentState>) {}

  public GetPaymentFilter(): Observable<FilterState> {
    return this.store.select(selector.getFilter);
  }

  public registerPayment(payment: Partial<RegisterDirectPayment>): void {
    this.store.dispatch(RegisterPayment({ change: payment }));
  }

  public fetchPaymentIntent(paymentIntentParams: PaymentIntentRequest, isAgreedAgeRestriction): void {
    return this.store.dispatch(FetchPaymentIntent({ paymentIntentParams, isAgreedAgeRestriction }));
  }

  public addPaymentIntent(paymentIntent: PaymentIntent): void {
    this.store.dispatch(AddPaymentIntent({ paymentIntent }));
  }

  public getPaymentIntent(): Observable<PaymentIntent> {
    return this.store.pipe(select(selector.getPaymentIntent));
  }

  public confirmPayment(transactionId: string, booking: Booking, participants): void {
    this.store.dispatch(ConfirmPaymentTransaction({ transactionId, booking, participants }));
  }

  public confirmGiftCardPayment(giftCard: GiftCard,booking: Booking): void {
    this.store.dispatch(ConfirmGiftCardPaymentTransaction({ giftCard, booking }));
  }

  public removePaymentIntent(): void {
    this.store.dispatch(RemovePaymentIntent());
  }

  public checkGiftCard(giftCode: string, bookingId: string): void {
    this.store.dispatch(CheckGiftCardCode({ giftCode, bookingId }));
  }

  public removeGiftCard(): void {
    this.store.dispatch(RemoveGiftCard());
  }

  public getGiftCard(): Observable<boolean> {
    return this.store.pipe(select(selector.getGiftCard));
  }
}
